"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardImage = exports.ThinLineccWrapper = exports.StyledCreditCardIcons = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// External
var StyledCreditCardIcons = _styledComponents.default.div.withConfig({
  displayName: "CreditCardIconsstyles__StyledCreditCardIcons",
  componentId: "sc-1watl6n-0"
})(["display:flex;width:250px;@supports(width:min-content){&{width:min-content;}}"]);

exports.StyledCreditCardIcons = StyledCreditCardIcons;

var ThinLineccWrapper = _styledComponents.default.span.withConfig({
  displayName: "CreditCardIconsstyles__ThinLineccWrapper",
  componentId: "sc-1watl6n-1"
})(["flex-grow:1;text-align:center;"]);

exports.ThinLineccWrapper = ThinLineccWrapper;

var CardImage = _styledComponents.default.img.withConfig({
  displayName: "CreditCardIconsstyles__CardImage",
  componentId: "sc-1watl6n-2"
})(["margin:0 .2rem;width:2rem;vertical-align:middle;"]);

exports.CardImage = CardImage;